import React from "react";
import { Card, CardBody, CardHeader, Col, Spinner } from "reactstrap";
import * as moment from "moment";

import { ActivityReportData } from "./types";

const initials = (name: string) =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

/** The people driving the traffic in the selected window. */
const MostActiveUsers = ({
  data,
  loading,
}: {
  data: ActivityReportData | null;
  loading: boolean;
}) => {
  const rows = data?.users || [];

  return (
    <Col xxl={6}>
      <Card className="card-height-100">
        <CardHeader className="align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1">Most Active Users</h4>
        </CardHeader>
        <CardBody>
          {loading ? (
            <div className="text-center py-5">
              <Spinner color="primary" size="sm" />
            </div>
          ) : rows.length === 0 ? (
            <div className="text-center text-muted py-5">
              No user activity matches the current filters.
            </div>
          ) : (
            <div className="table-responsive table-card">
              <table className="table align-middle table-borderless table-nowrap mb-0">
                <thead className="text-muted table-light">
                  <tr>
                    <th scope="col">User</th>
                    <th scope="col">Visits</th>
                    <th scope="col">Pages</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row) => (
                    <tr key={row.userId}>
                      <td>
                        <div className="d-flex align-items-center">
                          <div className="avatar-xs flex-shrink-0 me-2">
                            <span className="avatar-title bg-primary-subtle text-primary rounded-circle fs-11">
                              {initials(row.name)}
                            </span>
                          </div>
                          <div className="flex-grow-1 overflow-hidden">
                            <div className="fw-medium text-truncate">
                              {row.name}
                            </div>
                            <small className="text-muted text-truncate d-block">
                              {row.agencyName || row.email || ""}
                              {row.lastActiveAt
                                ? ` · ${moment(
                                    new Date(row.lastActiveAt)
                                  ).fromNow()}`
                                : ""}
                            </small>
                          </div>
                        </div>
                      </td>
                      <td>{row.visits}</td>
                      <td>{row.pagesVisited}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

export default MostActiveUsers;
